import React from 'react';
import { Route, NavLink, Redirect} from 'react-router-dom';
import Auth from '../../actions/authActions';

const PrivateRoute = ({ path, icon, name, ...rest }) => (
  // Auth.isAuthenticated === true ?
  localStorage.getItem('isAuthenticated') ?
  <NavLink
  to={path}
  className="nav-link"
  activeClassName="active"
>
  <i className={icon} />
  <p>{name}</p>
</NavLink>
:
<Redirect to={{
          pathname: '/login',
          state: { from: path }
        }} />

  // <NavLink {...rest} render={(props) => (
  //   Auth.isAuthenticated === true
  //     ? <Component {...props} />
  //     : <Redirect to={{
  //         pathname: '/login',
  //         state: { from: props.location }
  //       }} />
  // )} />
)

export default PrivateRoute;
